import { useRef } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { enqueueSnackbar } from 'notistack';
import { useSelector, useDispatch } from '../../../../../../redux/store';
import { deleteInvoice } from '../../../../../../api/invoicing';
import { markMetricRemoved, NotificationMetricType } from '../../../../../../redux/slices/notifications';

export const useDeleteAndNavigate = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const location = useLocation();
  const section = location.pathname.split('/')[3];
  const navigate = useNavigate();

  const { invoiceItemData } = useSelector((state) => state.invoicing).data;
  const idRef = useRef(id);
  const sectionRef = useRef(section);
  idRef.current = id;
  sectionRef.current = section;
  const deleteAndNavigate = async () => {
    const currentId = idRef.current;
    const currentSection = sectionRef.current;
    if (invoiceItemData?.invoice?.editingLocked) return false;
    const response = await deleteInvoice(currentId);

    if (response.data.success) {
      const invoicesInQueue = JSON.parse(localStorage.getItem('selectedInvoices') || '[]');
      const numericId = Number(currentId);
      const deletedInvoicePosInQueue = invoicesInQueue.indexOf(numericId);
      const updatedQueue = invoicesInQueue.filter((invId) => invId !== numericId);
      localStorage.setItem('selectedInvoices', JSON.stringify(updatedQueue || []));      
      if (!updatedQueue.length) {
        navigate(`/dashboard/invoicing/${currentSection}`);
      } else if (deletedInvoicePosInQueue < updatedQueue.length) {
        navigate(`/dashboard/invoicing/${currentSection}/${updatedQueue[deletedInvoicePosInQueue]}`);
      } else {
        navigate(`/dashboard/invoicing/${currentSection}/${updatedQueue[updatedQueue.length - 1]}`);
      }

      enqueueSnackbar('Invoice deleted successfully', {
        variant: 'success',
      });
      dispatch(markMetricRemoved(NotificationMetricType.InvoicesSubmitted, currentId));
      dispatch(markMetricRemoved(NotificationMetricType.InvoicesNeedApproval, currentId));

      return true;
    }
    enqueueSnackbar(response.data.message, {
      variant: 'error',
    });

    return false;
  };

  return deleteAndNavigate;
};
